import { useLocation } from 'react-router-dom'

import { CommandMenu } from '@/app/layout/CommandMenu'
import { useNavGroups } from '@/app/layout/nav-items'
import { RealtimeIndicator } from '@/app/layout/RealtimeIndicator'
import { NotificationBell } from '@/features/notifications/NotificationBell'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { Separator } from '@/components/ui/separator'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { messages } from '@/lib/messages'
import { cn } from '@/lib/utils'

/** Tam genişlikte, kenar menünün üstünde duran üst çubuk (sidebar-16 SiteHeader). */
export function Topbar() {
  const { pathname } = useLocation()
  const groups = useNavGroups()
  const group = groups.find((g) => g.items.some((i) => i.to === pathname))
  const item = group?.items.find((i) => i.to === pathname)

  return (
    <header className="border-border bg-background sticky top-0 z-50 flex h-(--header-height) w-full shrink-0 items-center gap-2 border-b px-4">
      <SidebarTrigger
        aria-label={messages.common.toggleSidebar}
        className="max-md:-ml-2 max-md:size-10"
      />
      <Separator orientation="vertical" className="mr-1 h-4" />
      {/* Telefonda breadcrumb sığmaz ve rapor sayfalarının başlığı yalnız ekran okuyucuya açık:
          logo (mobil menünün başlığında da var) yerine sayfanın adı görünür. */}
      <img
        src="/betontas.png"
        alt={messages.app.name}
        className={cn('h-6 w-auto shrink-0', item && 'max-sm:hidden')}
      />
      {item && <span className="min-w-0 truncate text-sm font-medium sm:hidden">{item.label}</span>}
      {group && item && (
        <Breadcrumb className="hidden min-w-0 sm:block">
          <BreadcrumbList className="flex-nowrap">
            <BreadcrumbItem key={`group-${group.label}`}>{group.label}</BreadcrumbItem>
            <BreadcrumbSeparator key="separator" />
            <BreadcrumbItem key={`item-${item.label}`} className="min-w-0">
              <BreadcrumbPage>{item.label}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      )}
      <div className="ml-auto flex items-center gap-2">
        <RealtimeIndicator />
        <NotificationBell />
        <CommandMenu />
      </div>
    </header>
  )
}
